import { faGlobe, faLock } from '@fortawesome/pro-regular-svg-icons'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ReportCharm } from './ReportCharm'

export const ReportStatusCharm: FC<{ status: 'public' | 'private' }> = ({
  status,
}) => {
  const { t } = useTranslation()

  return (
    <ReportCharm
      icon={status === 'public' ? faGlobe : faLock}
      label={
        status === 'public'
          ? t('features.reporting.public')
          : t('features.reporting.private')
      }
    />
  )
}
